import { FallbackProvider } from "@ethersproject/providers";
import {
  ERC20,
  ERC20__factory,
  PriceProvidersRepository,
  PriceProvidersRepository__factory,
  Silo,
  SiloIncentivesController,
  SiloIncentivesController__factory,
  SiloLens,
  SiloLens__factory,
  SiloRepository,
  SiloRepository__factory,
  Silo__factory,
  UniswapV3PriceProvider,
  UniswapV3PriceProvider__factory,
} from "@silo/typechain";
import { Contract } from "@ethersproject/contracts";
import {
  PriceProvidersRepositoryAddress,
  SiloLensAddress,
  SiloRepositoryAddress,
  UniswapV3PriceProviderAddress,
} from "@silo/addresses";
import { ChecksumAddress, ProtocolInstance } from "@silo/types";

export const createSiloRepositoryContract = ({
  provider,
  protocolInstance,
}: {
  provider: FallbackProvider;
  protocolInstance: ProtocolInstance;
}) => {
  return <SiloRepository>(
    new Contract(
      SiloRepositoryAddress[protocolInstance],
      SiloRepository__factory.abi,
      provider
    )
  );
};

export const createSiloContract = ({
  siloAddress,
  provider,
}: {
  siloAddress: ChecksumAddress;
  provider: FallbackProvider;
}) => <Silo>new Contract(siloAddress, Silo__factory.abi, provider);

export const createSiloLensContract = ({
  provider,
  protocolInstance,
}: {
  provider: FallbackProvider;
  protocolInstance: ProtocolInstance;
}) =>
  <SiloLens>(
    new Contract(
      SiloLensAddress[protocolInstance],
      SiloLens__factory.abi,
      provider
    )
  );

export const createPriceProvidersRepositoryContract = ({
  provider,
  protocolInstance,
}: {
  provider: FallbackProvider;
  protocolInstance: ProtocolInstance;
}) =>
  <PriceProvidersRepository>(
    new Contract(
      PriceProvidersRepositoryAddress[protocolInstance],
      PriceProvidersRepository__factory.abi,
      provider
    )
  );

export const createUniswapV3PriceProviderContract = ({
  provider,
  protocolInstance,
}: {
  provider: FallbackProvider;
  protocolInstance: ProtocolInstance;
}) =>
  <UniswapV3PriceProvider>(
    new Contract(
      UniswapV3PriceProviderAddress[protocolInstance],
      UniswapV3PriceProvider__factory.abi,
      provider
    )
  );

export const createSiloIncentivesControllerContract = ({
  provider,
  address,
}: {
  provider: FallbackProvider;
  address: string;
}) =>
  <SiloIncentivesController>(
    new Contract(address, SiloIncentivesController__factory.abi, provider)
  );
export const createErc20Contract = ({
  tokenAddress,
  provider,
}: {
  tokenAddress: ChecksumAddress;
  provider: FallbackProvider;
}) => <ERC20>new Contract(tokenAddress, ERC20__factory.abi, provider);

export const createIncentivesControllerContract = ({
  incentivesControllerAddress,
  provider,
}: {
  incentivesControllerAddress: ChecksumAddress;
  provider: FallbackProvider;
}) =>
  <SiloIncentivesController>(
    new Contract(
      incentivesControllerAddress,
      SiloIncentivesController__factory.abi,
      provider
    )
  );
